// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../client/web/myagent/app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../client/web/myagent/app/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../client/web/myagent/app/node_modules/css-loader/dist/cjs.js!../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Conversation List ===== */
.conv-list {
  padding: var(--spacing-sm);
}

/* ===== Conversation Items ===== */
.conv-item {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: background var(--transition-fast);
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  color: inherit;
  font: inherit;
}

.conv-item:hover {
  background: var(--bg-hover);
}

.conv-item-active {
  background: var(--bg-hover);
  border-left: 2px solid var(--color-primary);
}

.conv-item-btn {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  flex: 1;
  min-width: 0;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  color: inherit;
  font: inherit;
  text-align: left;
}

.conv-item-icon {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.conv-item-info {
  flex: 1;
  min-width: 0;
}

.conv-item-name {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.conv-item-hint {
  font-size: var(--font-size-xs);
  color: var(--text-tertiary);
}

.conv-item-delete {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  background: none;
  border: none;
  border-radius: var(--radius-md);
  color: var(--text-tertiary);
  cursor: pointer;
  opacity: 0;
  transition: all var(--transition-fast);
  flex-shrink: 0;
}

.conv-item:hover .conv-item-delete {
  opacity: 1;
}

.conv-item-delete:hover {
  color: var(--color-error);
  background: var(--bg-hover);
}

.conv-item-delete-confirm {
  opacity: 1;
  width: auto;
  padding: 2px 8px;
  font-size: var(--font-size-xs);
  color: var(--color-error);
  font-weight: var(--font-weight-medium);
}

/* ===== New Conversation ===== */
.conv-new-section {
  margin-top: var(--spacing-lg);
  padding-top: var(--spacing-md);
  border-top: 1px solid var(--glass-border);
}

.conv-new-label {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  text-transform: uppercase;
  letter-spacing: var(--letter-spacing-wider);
  color: var(--text-tertiary);
  padding: var(--spacing-xs) var(--spacing-sm);
  margin-bottom: var(--spacing-xs);
}

.conv-new-btn {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  width: 100%;
  padding: var(--spacing-sm);
  background: none;
  border: 1px dashed var(--glass-border);
  border-radius: var(--radius-md);
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
  cursor: pointer;
  transition: all var(--transition-fast);
  margin-bottom: var(--spacing-xs);
}

.conv-new-btn:hover {
  background: var(--bg-hover);
  border-color: var(--color-primary);
  color: var(--text-primary);
}

.conv-new-dot {
  width: 8px;
  height: 8px;
  border-radius: var(--radius-full);
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./../../../../packages/apps/myagent/myagent_ui/src/components/ConversationSidebar.css"],"names":[],"mappings":"AAEA,kCAAkC;AAClC;EACE,0BAA0B;AAC5B;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,+BAA+B;EAC/B,eAAe;EACf,6CAA6C;EAC7C,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,OAAO;EACP,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,2BAA2B;EAC3B,eAAe;EACf,UAAU;EACV,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA,iCAAiC;AACjC;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,yBAAyB;EACzB,2CAA2C;EAC3C,2BAA2B;EAC3B,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;EAChB,sCAAsC;EACtC,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,eAAe;EACf,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,cAAc;AAChB","sourcesContent":["@import \"../styles/variables.css\";\n\n/* ===== Conversation List ===== */\n.conv-list {\n  padding: var(--spacing-sm);\n}\n\n/* ===== Conversation Items ===== */\n.conv-item {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-sm);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: background var(--transition-fast);\n  border: none;\n  background: none;\n  width: 100%;\n  text-align: left;\n  color: inherit;\n  font: inherit;\n}\n\n.conv-item:hover {\n  background: var(--bg-hover);\n}\n\n.conv-item-active {\n  background: var(--bg-hover);\n  border-left: 2px solid var(--color-primary);\n}\n\n.conv-item-btn {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  flex: 1;\n  min-width: 0;\n  padding: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n}\n\n.conv-item-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-full);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.conv-item-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.conv-item-name {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.conv-item-hint {\n  font-size: var(--font-size-xs);\n  color: var(--text-tertiary);\n}\n\n.conv-item-delete {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  background: none;\n  border: none;\n  border-radius: var(--radius-md);\n  color: var(--text-tertiary);\n  cursor: pointer;\n  opacity: 0;\n  transition: all var(--transition-fast);\n  flex-shrink: 0;\n}\n\n.conv-item:hover .conv-item-delete {\n  opacity: 1;\n}\n\n.conv-item-delete:hover {\n  color: var(--color-error);\n  background: var(--bg-hover);\n}\n\n.conv-item-delete-confirm {\n  opacity: 1;\n  width: auto;\n  padding: 2px 8px;\n  font-size: var(--font-size-xs);\n  color: var(--color-error);\n  font-weight: var(--font-weight-medium);\n}\n\n/* ===== New Conversation ===== */\n.conv-new-section {\n  margin-top: var(--spacing-lg);\n  padding-top: var(--spacing-md);\n  border-top: 1px solid var(--glass-border);\n}\n\n.conv-new-label {\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-medium);\n  text-transform: uppercase;\n  letter-spacing: var(--letter-spacing-wider);\n  color: var(--text-tertiary);\n  padding: var(--spacing-xs) var(--spacing-sm);\n  margin-bottom: var(--spacing-xs);\n}\n\n.conv-new-btn {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  width: 100%;\n  padding: var(--spacing-sm);\n  background: none;\n  border: 1px dashed var(--glass-border);\n  border-radius: var(--radius-md);\n  color: var(--text-secondary);\n  font-size: var(--font-size-sm);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  margin-bottom: var(--spacing-xs);\n}\n\n.conv-new-btn:hover {\n  background: var(--bg-hover);\n  border-color: var(--color-primary);\n  color: var(--text-primary);\n}\n\n.conv-new-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: var(--radius-full);\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
